import React from 'react'
import styles from './lesson.styles'
import injectSheet from 'react-jss'
import { Route, withRouter } from 'react-router-dom'
import Builder from './builder/builder'
import { PromptsLayout } from '../../prompts-layout'

const Lesson = ({ classes, notFound, history, pending }) => {
  return (
    <PromptsLayout>
      <Route exact path="/lesson/:id" component={Builder} />
    </PromptsLayout>
  )
}

export default withRouter(injectSheet(styles)(Lesson))
